import './check'
import { Command } from "commander"
import { buildinfo } from "./share";
import { buildByTsup } from './engine/tsup';
import { buildComponentsVue3ByVite, buildSiteByVite, devSiteByVite } from './engine/vite';
import { defineConfig, EDefineConfig } from './share/type';
import { error } from './util';

const program = new Command();

program.name(__NAME__)
program.version(__VERSION__, "-v, --version").description("查看当前版本号");
program.helpOption("-h --help", "显示帮助信息");
program.showHelpAfterError(`(${__NAME__} -h 查看帮助信息)`);
program
    .option('-w, --watch', '开发模式')
    .option('-s, --site', '站点模式')
    .option('--ssr', 'ssr模式')
    .option('-d, --debug [value]', 'Debug日志')
    .description('构建')
    .action(async ({ watch, debug, site, ssr }) => {
        if(debug){
            // 开启日志
            process.env.DEBUG = typeof debug === 'boolean' ? '*' : debug
        }
        const isDev = !!watch
        buildinfo.watch = isDev
        const buildTsup = async () => {
            const mod = await import(`./engine/tsup/loadModule`)
            await mod.loadModule()
            buildByTsup()
        }
        const buildVite = async () => {
            const mod = await import(`./engine/vite/loadModule`)
            await mod.loadModule()
            if(site){
                if(isDev){
                    devSiteByVite()
                }else{
                    buildSiteByVite(ssr)
                }
            }else{
                buildComponentsVue3ByVite()
            }
        }
        if (["cli", "lib"].includes(buildinfo.mode)) {
            await buildTsup()
            return
        }
        if (["components-vue3"].includes(buildinfo.mode)) {
            await buildVite()
            return
        }
        error("请注意： 构建模式不可用")
    })

program.command("init")
    .description('初始化项目')
    .action(async ({ }) => {
        error("开发中，暂不可用")
    })

program.parse(process.argv);

export type {
    EDefineConfig
}
export {
    defineConfig
}